import React from 'react'

import { ListContainer as Container } from './style'

export const ListContainer: React.FunctionComponent = ({ children }) => {
    return <Container>{children}</Container>
}
